/**
 * Confirm / discard glyphs for the draft fly-outs (#216).
 *
 * These stay runtime constants rather than `<!-- svg:… -->` markers because the
 * fly-out buttons are built with `document.createElement` — six fly-outs,
 * created and positioned on demand — so there is no markup to carry a marker.
 * Reading the same `.svg` files through the same {@link stripIconSvg} keeps
 * them one source with the rest of the chrome.
 *
 * They previously carried `width="22" height="22"` inline, which is why they
 * could not be normalised: the strip removes those, and WebKit resolves a
 * viewBox-only SVG to zero. The size now lives in `styles.css` beside the
 * fly-out button rules, which is where every other button family keeps it.
 */
import checkRaw from "../icons/check.svg?raw";
import xRaw from "../icons/x.svg?raw";
import { stripIconSvg } from "../icons/stripIconSvg";

/** ✓ — finish the draft. */
export const CHECK_SVG = stripIconSvg(checkRaw);

/** ✗ — discard it. */
export const X_SVG = stripIconSvg(xRaw);
